import React from 'react';
import Loadable from 'react-loadable'
import _app from "../../server";

import { PrivateLayout } from 'components/layouts';

function Loading() {
    return <div>Loading...</div>;
}

// ======= Dashboard ===============
const Dashboard = Loadable({
    loader: () => import('components/views/Dashboard'),
    loading: Loading,
});

// ======= DeviceList =============
// Don't show DeviceList on public routes

// ======= Messages ===============


// ======= OffenceList ===============
const TrafficOffences = Loadable({
    loader: () => import('components/views/TrafficOffences'),
    loading: Loading,
})

// ======= Panic ===============
const Ongoing = Loadable({
    loader: () => import('components/views/Panic/Ongoing'),
    loading: Loading,
});
const OngoingDetail = Loadable({
    loader: () => import('components/views/Panic/Ongoing/OngoingDetail'),
    loading: Loading,
});
const Resolved = Loadable({
    loader: () => import('components/views/Panic/Resolved'),
    loading: Loading,
});
const ResolvedDetail = Loadable({
    loader: () => import('components/views/Panic/Resolved/ResolvedDetails'),
    loading: Loading,
});

// ======= Profile ===============
const Profile = Loadable({
    loader: () => import('components/views/Profile/Profile'),
    loading: Loading,
});


// ======= Reports ===============
const Active = Loadable({
    loader: () => import('components/views/Reports/Active'),
    loading: Loading,
});
const ActiveView = Loadable({
    loader: () => import('components/views/Reports/Active/ActiveView'),
    loading: Loading,
});
const Archived = Loadable({
    loader: () => import('components/views/Reports/Archived'),
    loading: Loading,
});
const ArchivedView = Loadable({
    loader: () => import('components/views/Reports/Archived/ArchivedView'),
    loading: Loading,
});


// ======= Summons ===============
const Issued = Loadable({
    loader: () => import('components/views/Summons/Issued'),
    loading: Loading,
});

const IssuedDetail = Loadable({
    loader: () => import('components/views/Summons/Issued/IssuedDetail'),
    loading: Loading,
});
const IssuedPrint = Loadable({
    loader: () => import('components/views/Summons/Issued/IssuedPrint'),
    loading: Loading,
});

const Rejected = Loadable({
    loader: () => import('components/views/Summons/Rejected'),
    loading: Loading,
});
const RejectedDetail = Loadable({
    loader: () => import('components/views/Summons/Rejected/RejectedDetail'),
    loading: Loading,
})

const Verified = Loadable({
    loader: () => import('components/views/Summons/Verified'),
    loading: Loading,
});
const VerifiedDetail = Loadable({
    loader: () => import('components/views/Summons/Verified/VerifiedDetail'),
    loading: Loading,
});



// ======= Touring ===============
const History = Loadable({
    loader: () => import('components/views/Touring/History'),
    loading: Loading,
});
const HistoryDetail = Loadable({
    loader: () => import('components/views/Touring/History/HistoryDetail'),
    loading: Loading,
});
const HistoryReport = Loadable({
    loader: () => import('components/views/Touring/History/HistoryDetail/Report'),
    loading: Loading,
});
const HistoryPrint = Loadable({
    loader: () => import('components/views/Touring/History/HistoryPrint'),
    loading: Loading,
});

const Live = Loadable({
    loader: () => import('components/views/Touring/Live'),
    loading: Loading,
});

const LiveDetail = Loadable({
    loader: () => import('components/views/Touring/Live/LiveDetail'),
    loading: Loading,
});

const Scheduler = Loadable({
    loader: () => import('components/views/Schedule/Schedule'),
    loading: Loading,
});






// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
let routes = [
    { path: '/', exact: true, name: 'Home', component: PrivateLayout },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },

    { path: '/profile', exact: true, name: 'Profile', component: Profile },

    { path: '/touring/live', exact: true, name: 'Live', component: Live },
    { path: '/touring/live/details', exact: true, name: 'Active', component: LiveDetail },
    { path: '/touring/history', exact: true, name: 'Tour History', component: History },
    { path: '/touring/history/details', exact: true, name: 'Log', component: HistoryDetail },
    { path: '/touring/history/details/report', exact: true, name: 'Report', component: HistoryReport },
    { path: '/touring/history/historyprint', exact: true, name: 'History Print', component: HistoryPrint },

    { path: '/reports/active', exact: true, name: 'Active Reports', component: Active },
    { path: '/reports/active/view', exact: true, name: 'View', component: ActiveView },
    { path: '/reports/archived', exact: true, name: 'Archived Reports', component: Archived },
    { path: '/reports/archived/view', exact: true, name: 'View', component: ArchivedView },

    { path: '/panic/ongoing', exact: true, name: 'Ongoing Panics', component: Ongoing },
    { path: '/panic/ongoing/details', exact: true, name: 'Active', component: OngoingDetail },
    { path: '/panic/resolved', exact: true, name: 'Resolved Panics', component: Resolved },
    { path: '/panic/resolved/details', exact: true, name: 'Log', component: ResolvedDetail },
];

if (_app.summon) {
    routes.push({ path: '/offences', exact: true, name: 'Traffic Offences', component: TrafficOffences });

    routes.push({ path: '/traffic/issued', exact: true, name: 'Compound Issued', component: Issued });
    routes.push({ path: '/traffic/issued/details', exact: true, name: 'Info', component: IssuedDetail });
    routes.push({ path: '/traffic/issued/print', exact: true, name: 'Info', component: IssuedPrint });
    routes.push({ path: '/traffic/verified', exact: true, name: 'Compound Verified', component: Verified });
    routes.push({ path: '/traffic/verified/details', exact: true, name: 'Info', component: VerifiedDetail });
    routes.push({ path: '/traffic/archived', exact: true, name: 'Compound Archived', component: Rejected });
    routes.push({ path: '/traffic/archived/details', exact: true, name: 'Info', component: RejectedDetail });
}
if (_app.scheduler) {
    routes.push({ path: '/touring/schedule', exact: true, name: 'Patrol Schedule', component: Scheduler });
}

export default routes;



// WEBPACK FOOTER //
// ./src/components/config/routes_pub.js